import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { VendordashboardService } from 'src/app/services/dashboard/vendor/vendordashboard.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs'
import { BehaviorSubject } from 'rxjs';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
import { Prevendor } from 'src/app/model/prevendor.model';
import { NgForm, FormsModule } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';
import { Gst } from 'src/app/model/gst.model';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-vendorregistration',
  templateUrl: './vendorregistration.component.html',
  styleUrls: ['./vendorregistration.component.css']
})
export class VendorregistrationComponent implements OnInit {

  currentUserData: any;
  vendorData: any;
  vModelData: Vendordata;
  form: FormGroup;
  vendorDocs: any;
  tturn: Number;
  teng: Number;
  tdip: Number;
  tother: Number;
  avg: Number;
  tiers: Gst[] = [];
  arr: object[];
  readonly rootUrl = environment.baseUrl;



  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService, private vendorDashboardService: VendordashboardService,
    private enlistmentServices: EnlistmentService, private fb: FormBuilder) {
    this.vModelData = new Vendordata();
    this.form = this.fb.group({
      avatar: null
    });
  }

  ngOnInit() {

    this.tiers = [];
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();

    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
        if (this.currentUserData != null) {
          var currentUserId = this.currentUserData.id;
          this.vendorDashboardService.getVendorData(currentUserId).subscribe(
            (data) => {
              this.vendorData = data;
              this.vModelData = this.vendorData;
              this.vModelData.financialYear1 = (yyyy - 1).toString();
              this.vModelData.financialYear2 = (yyyy - 2).toString();
              this.vModelData.financialYear3 = (yyyy - 3).toString();

              this.getVendorDocs();
              console.log(this.vModelData);
              debugger;
              if (this.vModelData.gstAddressArray.trim().length != 0 &&
                this.vModelData.gstRegArray.trim().length != 0 &&
                this.vModelData.gstStateArray.trim().length != 0) {

                var gstno = this.vModelData.gstRegArray.split(",");
                var gstaddress = this.vModelData.gstAddressArray.split(",");
                var gststate = this.vModelData.gstStateArray.split(",");

                for (var i = 0; i < gstno.length; i++) {
                  this.tiers.push(new Gst());
                }

                for (var i = 0; i < gstno.length; i++) {
                  this.tiers[i].dGstNo = gstno[i];
                  this.tiers[i].dGstAddress = gstaddress[i];
                  this.tiers[i].dGstState = gststate[i];
                }

              }
              else {
                //this.tiers[0] = { dGstNo: "", dGstAddress: "", dGstState: "" };
              }

            }
          )
        }
      }
    );

  }
  //validate
  AddSales() {
    this.tturn = Number(this.vModelData.salesTurnOver1) +
      Number(this.vModelData.salesTurnOver2) +
      Number(this.vModelData.salesTurnOver3);
    this.vModelData.totalTurnover = (this.tturn).toString();
    this.avg = Number((Number(this.tturn)) / 3);
    this.vModelData.avgTurnOverCurrency = (this.avg).toString();
  }
  AddEngg() {
    this.teng = (this.vModelData.engineersinManufacturing) +
      (this.vModelData.engineersInQA_Inspection) +
      (this.vModelData.engineersInAfterSalesService) +
      (this.vModelData.engineersInOtherDepartments);
    this.vModelData.totalEngineers = Number(this.teng);
  }
  AddDip() {
    this.tdip = (this.vModelData.dipHoldersInManufacturing) +
      (this.vModelData.dipHoldersInQA_Inspection) +
      (this.vModelData.dipHoldersInAfterSalesService) +
      (this.vModelData.dipHoldersInOtherDepartments);
    this.vModelData.totalDiplomaHolders = Number(this.tdip);
  }
  AddOther() {
    this.tother = (this.vModelData.othersInManufacturing) +
      (this.vModelData.othersInQA_Inspection) +
      (this.vModelData.othersInAfterSalesService) +
      (this.vModelData.othersInOtherDepartments);
    this.vModelData.totalOtherStuff = Number(this.tother);
  }

  CheckPan() {
    if (this.vModelData.panNo.length > 10 || this.vModelData.panNo.length < 0) {
      alert("PAN NO shoulde be of 10 characters");
    }
    //var pat = /^([A-Z]{5})(\d{4})([A-Z]{1})$/;
    for (var i = 0; i < 10; i++) {
      if (i >= 0 && i < 5) {
        alert("PAN NO should be in the format xxxxx1234x");

        if (i >= 5 && i < 9) {
          alert("PAN NO should be in the format xxxxx1234x");
          if (i >= 9 && i < 10) {
            alert("PAN NO should be in the format xxxxx1234x");
          }

        }
      }
    }

  }

  CheckGst() {
    if (this.vModelData.gSTNos.length < 0 && this.vModelData.gSTNos.length > 15) {

    }
  }

  ngAfterViewInit() {

  }

  uploadDocument() {
    let input = new FormData();
    input.append('avatar', this.form.get('avatar').value);
    input.append('documentType', this.vModelData.documentType);
    input.append('applicationNumber', this.vModelData.applicationNumber);
    input.append('currentUserId', this.vModelData.userId);
    input.append('module', 'vendorregistration');


    this.enlistmentServices.UploadVendorDocument(input).subscribe(
      (data: any) => {
        if (data == true) {
          this.getVendorDocs();
        }
        else {

        }
      }
    );

  }

  getVendorDocs() {
    let inputs = new FormData();
    inputs.append('applicationNumber', this.vModelData.applicationNumber);
    inputs.append('currentUserId', this.vModelData.userId);
    this.enlistmentServices.GetVendorDocs(inputs).subscribe(
      (data: any) => {
        this.vendorDocs = data;
        console.log(this.vendorDocs);
      }
    );
  }

  removeDoc = function (id) {
    this.enlistmentServices.removeVendorDocs(id).subscribe(
      (data: any) => {
        if (data == true) {
          this.getVendorDocs();
        }
        else {

        }
      }
    );
  }

  onFileChange(event) {
    //alert("selected");
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.form.get('avatar').setValue(file);

      console.log(this.form.get('avatar').value);
    }
  }

  SubmitEnlistmentForm(form: NgForm) {

    debugger;
    var gsterror = false;
    var panerror = false;
    form.value.gSTRegArray = "";
    form.value.gSTAddressArray = "";
    form.value.gSTStateArray = "";


    if (form.value.natureOfBusiness == "Registered") {
      if (!isNullOrUndefined(form.value.gstRegdNo) && !isNullOrUndefined(form.value.gstRegdAddress)
        && !isNullOrUndefined(form.value.state)) {

        if (form.value.gstRegdNo.trim().length != 0 &&
          form.value.gstRegdAddress.trim().length != 0 &&
          form.value.state.trim().length != 0) {
          var maingst_value = form.value.gstRegdNo.toUpperCase();
          var reg = /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/;
          if (maingst_value.match(reg)) {
          } else {
            gsterror = true;
          }
        }
        else {
          gsterror = true;
          //alert("please enter correct gst information");
        }

      }
      else {
        gsterror = true;
        alert("please enter correct gst information");
      }

      for (var i = 0; i < this.tiers.length; i++) {

        if (!isNullOrUndefined(this.tiers[i].dGstNo) && !isNullOrUndefined(this.tiers[i].dGstAddress)
          && !isNullOrUndefined(this.tiers[i].dGstState)) {

          if (this.tiers[i].dGstNo.trim().length != 0 &&
            this.tiers[i].dGstAddress.trim().length != 0 &&
            this.tiers[i].dGstState.trim().length != 0) {

            var gst_value = this.tiers[i].dGstNo.toUpperCase();
            var reg = /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/;
            if (gst_value.match(reg)) {
              //gsterror = false;
            } else {
              gsterror = true;
            }

            form.value.gSTRegArray = form.value.gSTRegArray + this.tiers[i].dGstNo;
            if (i < this.tiers.length - 1) {
              form.value.gSTRegArray = form.value.gSTRegArray + ',';
            }

            form.value.gSTAddressArray = form.value.gSTAddressArray + this.tiers[i].dGstAddress;
            if (i < this.tiers.length - 1) {
              form.value.gSTAddressArray = form.value.gSTAddressArray + ',';
            }

            form.value.gSTStateArray = form.value.gSTStateArray + this.tiers[i].dGstState;
            if (i < this.tiers.length - 1) {
              form.value.gSTStateArray = form.value.gSTStateArray + ',';
            }

          }
          else {
            gsterror = true;
            alert("please enter correct gst information");
          }
        }
        else {
          gsterror = true;
          alert("please enter correct gst information");
        }

      }

    }


    if (!isNullOrUndefined(form.value.panNo)) {
      if (form.value.panNo.trim().length != 0) {
        var pan_value = form.value.panNo.toUpperCase();
        var regpan = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/;
        if (pan_value.match(regpan)) {
          //gsterror = false;
        } else {
          gsterror = true;
          alert("please enter corrct pan number");
        }
      }
      else {
        panerror = true;
        alert("please enter corrct pan number");
      }
    }
    else {
      panerror = true;
      alert("please enter corrct pan number");
    }


    if (!gsterror && !panerror) {
      this.enlistmentServices.completeVendorRegistration(form.value).subscribe(
        (data) => {
          alert("Successfully Submitted");
          this.ngOnInit();
        }
      );
    }
    // else {
    //   alert("please enter correct gst information");
    // }

  }

  addTier() {
    this.tiers.push(new Gst());
    console.log(this.tiers);
  }

  // submitTier()
  // {
  //   console.log(this.tiers);
  // }

  deleteFieldValue(index) {
    this.tiers.splice(index, 1);
  }

}
